const RECEPCIONES = (state, recepciones) => {
    state.recepciones = recepciones;
};

const CONTENEDORES = (state, contenedores) => {
    state.contenedores = contenedores;
};

const RUTAS = (state, rutas) => {
    state.rutas = rutas;
};

// New mutations for invoice persistence
const SET_SELECTED_INVOICE = (state, invoice) => {
    state.selectedInvoice = invoice;
};

const SET_RECEIPT_TYPE = (state, type) => {
    state.receiptType = type;
};

const CLEAR_INVOICE_STATE = (state) => {
    state.selectedInvoice = null;
    state.receiptType = 'FACTURAS';
};

export default {
    RECEPCIONES,
    CONTENEDORES,
    RUTAS,
    SET_SELECTED_INVOICE,
    SET_RECEIPT_TYPE,
    CLEAR_INVOICE_STATE
};